import TravelerLog from "./TravelerLog"

export default class Sidebar {
  constructor({
    log,
    element,
  }) {
    this.log = log.forClass("Sidebar")
    this.element = element
    this.travelerLog = new TravelerLog({
      element: this.element.querySelector("[data-log]"),
      log: this.log,
      document: document,
    })
  }

  render(game, change) {
    this.travelerLog.render(game, change)
  }

  width() {
    return this.element.offsetWidth
  }

  show({width, height}) {
    this.element.style.display      = "block"
    this.element.style.height       = `${height}px`
  }

  hide() {
    this.element.style.display = "none"
  }

}
